const filterFavButton = document.getElementById("search-button-filter-fav")
const filterVisitedButton = document.getElementById("search-button-filter-visited")
const inputSearch = document.getElementById("search-input-courses")

let isFilterVisitedActivated = false
let isFilterFavActivated = false
let query = ''

if(filterVisitedButton) {
    filterVisitedButton.onclick = () => {
        let icon = !isFilterVisitedActivated ?  'eye_fill.svg' : 'eye.svg'
        if(isFilterVisitedActivated) {
            isFilterVisitedActivated = false
        } else {
           isFilterVisitedActivated = true
        }

        document.getElementById('search-button-filter-visited-icon').setAttribute('src', `https://d2wl56ig1uoitb.cloudfront.net/images/${icon}`)

        diggestView()
    }
}

if(filterFavButton) {
    filterFavButton.onclick = () => {
        let icon = !isFilterFavActivated ? 'star_fill.svg' : 'star.svg'
        if(isFilterFavActivated) {
            isFilterFavActivated = false
        } else {
            isFilterFavActivated = true
        }

        document.getElementById('search-button-filter-fav-icon').setAttribute('src', `https://d2wl56ig1uoitb.cloudfront.net/images/${icon}`)
        diggestView()
    }
}

if(inputSearch) {
    inputSearch.onkeyup = (event) => {
        query = event.target.value
        diggestView()
    }
}


function diggestView() {
    const isFiltering = isFilterVisitedActivated || isFilterFavActivated || query.length > 0

    if(!isFiltering) {
        document.getElementById("results-course-search").classList.add("hidden")
        document.getElementById("accordion-courses").classList.remove("hidden")

        return;
    }

    const buffer = [];
    const selector = document.querySelectorAll('[course-result="1"]');

    const div = document.createElement('div')

    for(let s of selector) {
        let include = false
        if(isFilterVisitedActivated && s.attributes['data-isVisited'].value == 1) include = true
        if(isFilterFavActivated && s.attributes['data-isFav'].value == 1) include = true
        if(query.length > 0 && s.attributes['data-search'].value.indexOf(query) !== -1) include = true

        if(include) div.append(s.cloneNode(true))
    }
    document.getElementById("results-course-search").innerHTML = div.innerHTML

    document.getElementById("accordion-courses").classList.add("hidden")
    document.getElementById("results-course-search").classList.remove("hidden")


}
